import type { ServiceReminderQueueFilters } from '@hetivo/hetivo-lib-types';

import type { MasterContextValue } from '&/master';

/** The two request fields the master selection fills; the same names and meaning as the vehicles search. */
export type MasterSelectionFilters = Pick<ServiceReminderQueueFilters, 'locationIds' | 'territoryIds'>;

/** True when the master selection narrows the queue to a territory or a location. */
export function hasMasterSelection(selection: MasterSelectionFilters): boolean {
  return selection.locationIds !== undefined || selection.territoryIds !== undefined;
}

/**
 * What the master selector (territory or location) adds to a queue request (decision #27): a selected site
 * narrows to that location, else a selected territory narrows to its locations (resolved server-side), and
 * "All locations" adds nothing. The caller's own location scope still applies on the server on top of it,
 * so a selection narrows and never widens.
 */
export function masterSelectionFilters({
  siteId,
  territoryId,
}: Pick<MasterContextValue, 'siteId' | 'territoryId'>): MasterSelectionFilters {
  if (siteId) {
    return { locationIds: [siteId] };
  }
  if (territoryId) {
    return { territoryIds: [territoryId] };
  }
  return {};
}
